/* eslint-disable  */
/* eslint-disable object-property-newline */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useMemo } from 'react';

import {
    Grid,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Container,
    Button,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableHead,
    Input,
    Chip,
    Typography,
    Modal

} from '@material-ui/core';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Link from '@mui/material/Link';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import crypto from 'crypto';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import Dimmer from '+/Dimmer';
import { useReadAmenityNotes } from '~/orders';
import { getUnitType } from '../orders/utils/utils';
import { useGetAllUnitsInProperty, useFetchUnitTypeMappingsByProperty } from '../../api/orders';
import {
    filter, omit, intersection
} from 'lodash';

import {
    MenuProps,
    useStyles,
    getUniqueAmenityNames,
    getFilterValues
} from './utils';

import OrderModal from './OrderModal';
import PrintCsv from './PrintCsv';


dayjs.extend(isBetween);

const styles = {
    chips: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    chip: {
        margin: 2
    }
};

const initialState = {
    building: [],
    floor: [],
    unit_type: [],
    amenityName: [],
    startDate: null,
    endDate: null
};

const defaultData = {
    property: {},
    inEntrata: [],
    notInEntrata: []
};


const AmenityReport = props => {
    const classes = useStyles();
    const { match } = props;
    const { property_id } = match.params;

    const [filteredData, setFilteredData] = useState([]);
    const [formState, setFormState] = useState(initialState);
    const [openModal, setOpenModal] = React.useState(false);

    const handleCloseModal = () => setOpenModal(false);
    const [modalValues, setModalValues] = useState({});

    
    const [selectedAmenities, setSelectedAmenities] = useState([]);

    const { data: allUnitsWithAmenities = defaultData } = useReadAmenityNotes(property_id);
    const { data: unitTypeMappings = [], isFetching: isFetchingUnitType } = useFetchUnitTypeMappingsByProperty(property_id);
    let { data: allUnitsInProperty = [], isFetching: isFetchingAllUnitsInProperty } = useGetAllUnitsInProperty(property_id);

    const [unitType, setUnitType] = useState(false);


    const handleOpenModal = (row, amenity_name, value) => {

        if (amenity_name === 'Union'){
            if (row.intersections.length > 0){
                setModalValues({
                    property_name: row.property_name,
                    row,
                    amenity_name,
                    value,
                    selectedAmenities
                });
                setOpenModal(true);
            }
        }

        if (row[amenity_name]?.size > 0){
            setModalValues({
                property_name: row.property_name,
                row,
                amenity_name,
                value
            });
            setOpenModal(true);
        }
    };

    const handleAmenityChange = value => {

        if (value[value.length - 1] === 'all') {
            setSelectedAmenities(selectedAmenities.length === amenityNames.length ? [] : amenityNames);

            return;
        }
        setSelectedAmenities(value);
    };

    const handleFormChange = (field, value) => {

        setFormState(currentState => ({
            ...currentState,
            [field]: value
        }));

    };

    const handleUnitType = e => {

        setUnitType(e.target.checked);

    };

    const resetFilters = () => {
        setFormState(initialState);
        setSelectedAmenities([]);
    };

    const amenityUnits = useMemo(
        () => parseData(
            [].concat(
                allUnitsWithAmenities.inEntrata,
                allUnitsWithAmenities.notInEntrata
            ),
            unitTypeMappings
        ),
        [allUnitsWithAmenities, unitTypeMappings]
    );

    // console.log(amenityUnits[0])

    const uniqueUnitsInProperty = useMemo(() => new Set(allUnitsInProperty.map(u => u.bldg_unit)), [allUnitsInProperty]);
    const _countPropTotals = (building, row ) => {
        return 5;
    }
    let building;
    let floor;
    let unit_type;
    const countPropTotals = (row, i, array) => {

        // let floor;
        // let building;
        // let unit_type;
        if (row.building){
            building = row.building;
            return allUnitsInProperty.filter((unit) => unit.building === building).length
        } else if ( row.floor) {
            floor = row.floor;
           

            return allUnitsInProperty.filter((unit) => {

                return unit.building === building && unit.floor == floor
            }).length
        } else {
            unit_type = row.unit_type;
            return allUnitsInProperty.filter((unit) =>  unit.building === building && unit.floor == floor && unit.unit_type === unit_type).length
        }
       
    }

    const unitsWithAmenities = useMemo(() => new Set(
        amenityUnits.map(u => u.unit_space_name)
    ), [amenityUnits]);

    const propertyUnits = useMemo(
        () => (

            parseData(
                [].concat(
                    amenityUnits.filter(u => uniqueUnitsInProperty.has(u.unit_space_name)),
                    allUnitsInProperty.filter(u => !unitsWithAmenities.has(u.bldg_unit))
                )
            )
        ),
        [
            amenityUnits,
            allUnitsInProperty,
            uniqueUnitsInProperty,
            unitsWithAmenities
        ]
    );


    const propertyUnitCounts = useMemo(
        () => getCounts(propertyUnits, []),
        [propertyUnits]
    );

    const filteredUnitsCount = useMemo(
        () => getCounts(filteredData, selectedAmenities),
        [filteredData, selectedAmenities]
    );

    const displayData = useMemo(() => Object.values(filteredUnitsCount?.data), [filteredUnitsCount]);
    // console.log(displayData);

    const amenityNames = useMemo(

        () => getUniqueAmenityNames(amenityUnits),
        [amenityUnits]
    );

    const filterValues = useMemo(

        () => getFilterValues(propertyUnits),
        [propertyUnits]
    );

    useEffect(() => {

        if (!isFetchingAllUnitsInProperty && !isFetchingUnitType) {
            setFilteredData(
                filterData(propertyUnits, formState)
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formState, propertyUnits]);

    if (
        isFetchingAllUnitsInProperty ||
        isFetchingUnitType ||
        !allUnitsInProperty?.length
    ) return <Dimmer />;

    const isAllSelected = amenityNames.length > 0 && selectedAmenities.length === amenityNames.length;

    // eslint-disable-next-line no-mixed-operators
    const property_name = allUnitsInProperty && allUnitsInProperty[0]?.property_name || '';


    return (
        <div>
            <Container>
                <Typography variant='h4' color='secondary'>{property_name}</Typography>
                <Grid alignItems='center' container spacing={4}>
                    <Grid item xs={3}>
                        <FormControl fullWidth>
                            <InputLabel>Building</InputLabel>
                            <Select
                                multiple
                                multiline
                                input={<Input id='select-multiple-chip' />}
                                renderValue={selected => (
                                    <div style={styles.chips}>
                                        {selected.map(value => (
                                            <Chip key={value} label={value} style={styles.chip} />
                                        ))}
                                    </div>
                                )}
                                value={formState.building}
                                onChange={e => handleFormChange('building', e.target.value)}
                            >
                                {filterValues.buildings.map(bldg => <MenuItem key={bldg} value={bldg}>{bldg}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        <FormControl fullWidth>
                            <InputLabel>Floor</InputLabel>
                            <Select
                                multiple
                                multiline
                                input={<Input id='select-multiple-chip' />}
                                renderValue={selected => (
                                    <div style={styles.chips}>
                                        {selected.map(value => (
                                            <Chip key={value} label={value} style={styles.chip} />
                                        ))}
                                    </div>
                                )}
                                value={formState.floor}
                                onChange={e => handleFormChange('floor', e.target.value)}
                            >
                                {filterValues.floors.map(floor => <MenuItem key={floor} value={floor}>{floor}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        <FormControl fullWidth>
                            <InputLabel>Unit Type</InputLabel>
                            <Select
                                multiple
                                multiline
                                input={<Input id='select-multiple-chip' />}
                                renderValue={selected => (
                                    <div style={styles.chips}>
                                        {selected.map(value => (
                                            <Chip key={value} label={value} style={styles.chip} />
                                        ))}
                                    </div>
                                )}
                                value={formState.unit_type}
                                onChange={e => handleFormChange('unit_type', e.target.value)}
                            >
                                {filterValues.unitTypes.map(unit_type => <MenuItem key={unit_type} value={unit_type}>{unit_type}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        <FormControl className={classes.formControl}>
                            <InputLabel >Amenity Names</InputLabel>
                            <Select
                                multiple
                                value={selectedAmenities}
                                onChange={e => handleAmenityChange(e.target.value)}
                                renderValue={selected => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                                <MenuItem
                                    value='all'
                                    classes={{
                                        root: isAllSelected ? classes.selectedAll : ''
                                    }}
                                >
                                    <ListItemIcon>
                                        <Checkbox
                                            classes={{ indeterminate: classes.indeterminateColor }}
                                            checked={isAllSelected}
                                            indeterminate={
                                                selectedAmenities.length > 0 && selectedAmenities.length < amenityNames.length
                                            }
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.selectAllText }}
                                        primary='Select All'
                                    />
                                </MenuItem>
                                {amenityNames.map(option => (
                                    <MenuItem key={option} value={option}>
                                        <ListItemIcon>
                                            <Checkbox checked={selectedAmenities.indexOf(option) > -1} />
                                        </ListItemIcon>
                                        <ListItemText primary={option} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label='Start Date (Date Paid)'
                                inputVariant='outlined'
                                value={formState.startDate}
                                onChange={value => handleFormChange('startDate', value)}
                                disableToolbar
                                fullWidth
                                format='MM/dd/yyyy'
                                id='start-date-picker-inline'
                                renderInput={params => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={3}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>

                            <DatePicker
                                label='End Date (Date Paid)'
                                inputVariant='outlined'
                                value={formState.endDate}
                                onChange={value => handleFormChange('endDate', value)}
                                disableToolbar
                                fullWidth
                                format='MM/dd/yyyy'
                                id='end-date-picker-inline'
                                renderInput={params => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={3}>
                        <FormGroup >
                            <FormControlLabel control={<Switch />} label='Unit Type' onClick={handleUnitType}/>
                        </FormGroup>
                    </Grid>


                </Grid>
                <Grid container justifyContent='space-between' spacing={5}>
                    <Grid item>
                        <PrintCsv
                            propertyName={property_name}
                            data={displayData || []}
                            filteredUnitsCount={filteredUnitsCount}
                            totalUnions={propertyUnitCounts.totalUnions}
                            selectedAmenities={selectedAmenities}
                        />
                    </Grid>
                    <Grid item>
                        <Button size='small' variant='contained' onClick={resetFilters}>
                            Reset Filters
                        </Button>
                    </Grid>
                </Grid>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Building</TableCell>
                            <TableCell>Floor</TableCell>
                            { unitType && <TableCell>Unit Type</TableCell>}
                            <TableCell>Unit Count</TableCell>
                            {selectedAmenities.map(x => (

                                <TableCell>{x}</TableCell>
                            ))}
                            { selectedAmenities.length > 1 && (

                                <TableCell>Union</TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow style={{ backgroundColor: '#CCFFCC', fontWeight: 'bold' }}>
                            <TableCell >Total</TableCell>
                            <TableCell></TableCell>
                            { unitType && <TableCell></TableCell>}
                            <TableCell sx={{ fontWeight: 'bold' }}>{uniqueUnitsInProperty.size}</TableCell>
                            {selectedAmenities.map(amenityName => (

                                <TableCell>
                                    {filteredUnitsCount?.amenities[amenityName]}
                                </TableCell>
                            ))}
                            { selectedAmenities.length > 1 && (

                                <TableCell>{ filteredUnitsCount?.totalUnions }</TableCell>
                            )}
                        </TableRow>
                        {
                            displayData.map((row, i, array) => {

                                // console.log(row);
                                // console.log('wtf')

                                const tot_units = [...new Set(propertyUnitCounts?.data[row.id]?.units)];

                            

                                return (!row.unit_type || unitType) && (

                                    <TableRow key={i}>
                                        <TableCell>{row.building}</TableCell>
                                        <TableCell>{row.floor}</TableCell>
                                        {unitType && <TableCell>{row.unit_type}</TableCell>}
                                        <TableCell>{countPropTotals(row, i, array)}</TableCell>
                                        {selectedAmenities.map(amenityName => (
                                        // eslint-disable-next-line max-len
                                            <TableCell >
                                                {row[amenityName]?.size > 0 &&
                                                    <Link
                                                        component='button'
                                                        variant='body2'
                                                        onClick={e => handleOpenModal(row, amenityName, row[amenityName]?.size)}>

                                                        {row[amenityName]?.size}
                                                    </Link>
                                                }
                                                {row[amenityName]?.size === 0 &&
                                                        row[amenityName]?.size
                                                }

                                            </TableCell>
                                        ))}
                                        { selectedAmenities.length > 1 && (

                                            <TableCell>
                                                {row.intersections.length > 0 &&
                                                    <Link
                                                        component='button'
                                                        variant='body2'
                                                        onClick={e => handleOpenModal(row, 'Union', row.intersections.length)}>

                                                        {row.intersections.length}
                                                    </Link>
                                                }
                                                {row.intersections.length === 0 &&
                                                        row.intersections.length
                                                }
                                            </TableCell>
                                        )}

                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </Container>

            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                >
                    <OrderModal row={modalValues}> </OrderModal>
                </Modal>
            </div>
        </div>
    );
};


const filterData = (data, formState) => filter(data, item => {

    const bldgMatch = formState.building.length === 0 || formState.building.includes(item.building);
    const floorMatch = formState.floor.length === 0 || formState.floor.includes(item.floor);
    const unitTypeMatch = formState.unit_type.length === 0 || formState.unit_type.includes(item.unit_type);
    const filterByDate = formState.startDate && formState.endDate;


    if (filterByDate) {

        if (!item.date_paid) {
            return false;
        }

        return dayjs(item.date_paid).isBetween(formState.startDate, formState.endDate) && bldgMatch && floorMatch && unitTypeMatch;
    }

    return bldgMatch && floorMatch && unitTypeMatch;
});

const getCorrectFloorNo = (_unitNumber, lookup_code) => {

    if (_unitNumber.includes("65")){
        console.log(_unitNumber)
    }


    if (!_unitNumber.includes("-")) {
        return 200
    }

    let unitNumber = _unitNumber.split('-')[1]

    if (lookup_code === '121') {

        return 1;
    }

    if(lookup_code === '081' || lookup_code === '81' ) {

        if (unitNumber.charAt(1) === '0') {
            return parseInt(unitNumber.charAt(2))
        } else {
            return parseInt(unitNumber.charAt(1))
        }
    }

    if (unitNumber.charAt(0) === '0'){
        
        unitNumber = unitNumber.slice(1, unitNumber.length)
    }

   
    let unitNumberNoStudio = unitNumber 
    if ( !parseInt(unitNumber.slice(-1))){ 
       unitNumberNoStudio = unitNumber.substring(0, unitNumber.length-1); 
    }


    if (unitNumberNoStudio.length > 3) {

        return parseInt(unitNumber.slice(0,2))        

    }
    else {

        return parseInt(unitNumber.slice(0,1))
    }
}

const parseData = (entrataData = [], unitTypeMappings) => (
    entrataData.map(item => {

      
        const {
            unit_space_name: unitName,
            bldg_unit,
            unit_type
        } = item;

        // if (unitName === "900-D030") {
        //     console.log(item)
        //     console.log('so cloooooose....')
        // }

        const hasBuildingInName = (unitName || bldg_unit).includes('-');
        const [_bldg, _unit] = (unitName || bldg_unit).split('-');
        const unitTypeName = unit_type || getUnitType(item, unitTypeMappings);
        // if (!unitTypeName) {
        //     console.log(item)
        // }
        const buildingNo = hasBuildingInName ? _bldg : '1';
        let floorNo;
        if (item.lookup_code === '121') {

            floorNo = 1;
        } else {
            floorNo = item.floor || getCorrectFloorNo(  (unitName || bldg_unit),  item.lookup_code)
        }

        if ([10,20,30,40].includes(floorNo ) && item.lookup_code === '046'  )  {
            floorNo =  floorNo/10
        }
        // console.log(floorNo)
    
        // if (!floorNo) {
        //     console.log(item)
        // }
        const unit = _unit || _bldg;

        return {
            ...item,
            building: buildingNo,
            floor: floorNo,
            unit_type: unitTypeName,
            unit
        };
    })
);

const getCounts = (_filteredData = [], selectedAmenities = []) => {

    const counts = {};
    const data = {};
    const amenities = {};
    let totalUnions = 0;

    // console.log(filteredData[0]);
    // console.log('hello bob');

    let filteredData = _filteredData.map( (item) => {
        return {
            unit_type: item.unit_type,
            building: item.building,
            floor: item.floor,
            unit: item.unit,
            amenity_name: item.amenity_name
        } 
    })

    // console.log(filteredData[0]);

    for (const item of filteredData) {

        // console.log(item);

        const {
            unit_type: unitTypeName,
            building: buildingNo,
            floor: floorNo,
            unit
        } = item;

        const building = counts[buildingNo] || {
            floors: {},
            intersections: [],
            units: []
        };

        const floor = building.floors[floorNo] || {
            unitTypes: {},
            intersections: [],
            units: []
        };

        const unitType = floor.unitTypes[unitTypeName] || {

            intersections: [],
            units: []
        };

        for (const amenity of selectedAmenities) {

            building[amenity] = building[amenity] || new Set();
            floor[amenity] = floor[amenity] || new Set();
            unitType[amenity] = unitType[amenity] || new Set();
            // console.log(amenity);
            // console.log(item.amenity_name)
            // console.log('----------')
            if (amenity === item.amenity_name) {

                building[amenity].add(unit);
                floor[amenity].add(unit);
                unitType[amenity].add(unit);

                amenities[amenity] = (amenities[amenity] || 0) + 1;
            }

        }

        building.units.push(unit);
        floor.units.push(unit);
        unitType.units.push(unit);

        floor.unitTypes[unitTypeName] = unitType;
        building.floors[floorNo] = floor;
        counts[buildingNo] = building;
    }

    for (const b in counts) {

        const building = counts[b];

        for (const f in building.floors) {

            const floor = building.floors[f];

            for (const u in floor.unitTypes) {

                const unitType = floor.unitTypes[u];

                const unitSets = Object.values(

                    omit(unitType, 'intersections')
                ).map(_set => [..._set]);

                // console.log(unitSets);
                // console.log('unitSets');


                const intersections = intersection(...unitSets);

                // console.log(intersections);
                // console.log('intersections');

                // console.log(unitType.intersections);
                // console.log('unitType.intersections');
                // console.log(floor.intersections);
                // console.log('floor.intersections');
                // console.log(building.intersections);
                // console.log('building.intersections');

                unitType.intersections = [].concat(unitType.intersections, intersections);
                floor.intersections = [].concat(floor.intersections, intersections);
                building.intersections = [].concat(building.intersections, intersections);
            }
        }
    }

    const makeId = str => (

        crypto.createHmac('sha1', 'whatever').update(str).digest('hex')
    );

    for (const b in counts) {

        const building = counts[b];

        const buildingRow = omit({
            ...building,
            building: b,
            id: makeId(b)
        }, 'floors');

        data[buildingRow.id] = buildingRow;

        totalUnions += buildingRow.intersections.length;

        for (const f in building.floors) {

            const floor = building.floors[f];

            const floorRow = omit({
                ...floor,
                floor: f,
                id: makeId(b + f)
            }, 'unitTypes');

            data[floorRow.id] = floorRow;

            for (const u in floor.unitTypes) {

                const unitType = floor.unitTypes[u];

                const unitTypeRow = {
                    ...unitType,
                    unit_type: u,
                    id: makeId(b + f + u)
                };

                data[unitTypeRow.id] = unitTypeRow;
            }
        }
    }


    return {
        counts,
        data,
        amenities,
        totalUnions
    };
};


export default AmenityReport;

